import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCurrentUserIsGuest,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import updateAccountSettings from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea, { TextAreaPresentationProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import submitContactForm from "@TKCCP/Handlers/contactFormHandler";
import isEmpty from "lodash/isEmpty";
import React, { ChangeEvent, FC, ReactNode, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import logger from "@insite/client-framework/Logger";

interface CountryCodeList {
    fields: {
        countryCode: string;
        countryCodeDisplay: string;
    };
}
interface SelectList {
    fields: {
        SelectList: string;
        SelectValue: string;
    };
}

interface Memberlist {
    fields: {
        ProductImg: string;
        ProductTitle: string;
        ProductNumber: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.countryCodedivision]: CountryCodeList[];
        [fields.selectDivision]: SelectList[];
        [fields.emailRecipients]: string;
        [fields.minimumHeight]: "fullViewport";
        [fields.divisions]: Memberlist[];
    };
}
const enum fields {
    divisions = "divisions",
    countryCodedivision = "countryCodedivision",
    selectDivision = "selectDivision",
    emailRecipients = "emailRecipients",
    background = "background",
    image = "image",
    ProductImage = "ProductImage",
    backgroundColor = "backgroundColor",
    minimumHeight = "minimumHeight",
}
const mapDispatchToProps = {
    loadCurrentCountries,
    submitContactForm,
    setInitialValues,
    loadCurrentAccount,
    getCurrentAccountState,
};

const mapStateToProps = (state: ApplicationState) => ({
    countries: getCurrentCountries(state),
    editingAccount: state.pages.accountSettings.editingAccount,
    userDetails: getSession(state),
    emailErrorMessage: state.pages.accountSettings.emailErrorMessage,
    currentLanguage: state.context.session.language,
    useEmailAsUserNameTest: getSettingsCollection(state).accountSettings,
    shouldLoadAccount: !getCurrentAccountState(state).value,
    currentAcc: getCurrentAccountState(state).value,
    location: getLocation(state),
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CreateAccountStyles {
    form?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    divWrapContainer?: GridItemProps;
    emailGridItem?: GridItemProps;
    doNotShow?: InjectableCss;
    ItemColumn?: InjectableCss;
    emailTextField?: TextFieldPresentationProps;
    messageTextField?: GridItemProps;
    textboxArea?: TextAreaPresentationProps;
    userNameGridItem?: GridItemProps;
    lastNameGridItem?: GridItemProps;
    inputFieldGridItem?: GridItemProps;
    whereToSendGridItem?: GridItemProps;
    cityWrapGridItem?: GridItemProps;
    coffeeWrapGridItem?: GridItemProps;
    boldTextSpan?: TypographyPresentationProps;
    SecondBold?: TypographyPresentationProps;
    TextSpan?: InjectableCss;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    passwordIcon?: IconPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    passwordRequirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordGridContainer?: GridContainerProps;
    checkboxStyle?: InjectableCss;
    ContactUs?: InjectableCss;
    signINButton?: InjectableCss;
    SelectIconSvg?: SelectPresentationProps;
    ManditoryField?: GridItemProps;
    buttonLink?: LinkPresentationProps;
    PhoneBoxWrapper?: GridItemProps;
    BackgroundWrapper?: InjectableCss;
    FlexBlox?: InjectableCss;
    ProductRow?: InjectableCss;
    FlexBlox1?: InjectableCss;
    ImgHight?: InjectableCss;
    Right?: InjectableCss;
    Title?: InjectableCss;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
}

export const createAccountStyles: CreateAccountStyles = {
    form: {
        css: css`
            margin: 20px 0;
            margin-bottom: 0px !important;
        `,
    },
    userNameTextField: {
        css: css`
            text-transform: capitalize;
        `,
    },
    BackgroundWrapper: {
        css: css`
            background-color: white;
            margin-bottom: 40px !important;
            margin: auto;
            border: 1px solid grey;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-right: auto;
                        padding: 0px 20px;
                        width: 80%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    Title: {
        css: css`
            padding: 30px;
        `,
    },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    submitButton: {
        css: css`
            width: 354px;
            text-align: center;
            justify-content: center;
            text-transform: capitalize;
            margin-top: 10px;
            margin-bottom: 30px;
            padding: 0px 25px;
            &:hover {
                background: ${getColor("primary")};
                border: 1px solid ${getColor("primary")};
                &:disabled {
                    background: #939393;
                    border-color: #939393;
                }
            }
            span {
                opacity: 1;
                color: ${getColor("info.contrast")} !important;

                text-align: center;
                justify-content: center;
            }
        `,
    },
    userGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-direction: column;
            /* justify-content: center; */
            div[class^="GridWrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-width: 350px;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])};
            }
            div[class^="GridItemStyle"] {
                padding-top: 0px !important;
                padding-bottom: 3px;
            }
        `,
    },
    doNotShow: {
        css: css`
            display: none;
        `,
    },
    userGridContainer: {
        css: css`
            padding-top: 30px;
            /* margin: auto; */
            display: flex;
            justify-content: end !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            /* max-width: 350px; */
                            padding: 0 15px;
                        `,
                    ],
                    "min",
                )};
        `,
    },

    divWrapContainer: {
        css: css`
            display: grid;
            grid-template-columns: repeat(3, 100fr);
            grid-gap: 10px;
            padding: 0px;
            max-width: 100%;
            flex-basis: auto;
            width: 100%;
            margin-bottom: 10px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(1, 100fr);
                    `,
                    css`
                        grid-template-columns: repeat(1, 100fr);
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },

    whereToSendGridItem: {
        css: css`
            display: block;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 0px;
        `,
    },

    cityWrapGridItem: {
        css: css`
            display: grid;
            grid-template-columns: repeat(3, 31.1%);
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 0px;
            grid-column: 1 /3;
            grid-gap: 10px;
        `,
    },

    coffeeWrapGridItem: {
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 0px;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
            margin-left: 50px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 15px !important;
                    `,
                    css`
                        margin: 15px !important;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    ItemColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-left: 15px;
            width: 100%;
        `,
    },

    boldTextSpan: {
        css: css`
            font-weight: bold;
            padding: 0 2px;
            margin-bottom: 10px;
            font-size: x-large;
        `,
    },

    SecondBold: {
        css: css`
            margin-bottom: 20px;
        `,
    },

    TextSpan: {
        css: css`
            font-weight: bold;
            padding: 0 2px;
            margin-top: 10px;
            margin-bottom: 10px;
            width: 90%;
            margin-left: 20px;
        `,
    },
    checkboxStyle: {
        css: css`
            justify-content: start !important;
            align-items: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 20px;
                    `,
                    css`
                        margin-left: 20px;
                    `,
                    css`
                        margin-left: 20px;
                    `,
                    null,
                    null,
                ])};
            > span {
                margin-top: 4px;
                border-radius: 0 !important;
                border: 1px solid ${getColor("secondary")} !important;
                box-shadow: none !important;
            }
            > span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background-color: primaryBlue;
            }
        `,
    },
    ContactUs: {
        css: css`
            justify-content: start !important;
            align-items: start;
            color: green !important;
            > span {
                margin-top: 4px;
                border-radius: 0 !important;
                border: 1px solid ${getColor("secondary")} !important;
                box-shadow: none !important;
                color: green !important;
            }
            > span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background-color: Green;
            }
            div {
                margin-left: 20px;
            }
        `,
    },

    inputFieldGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > input[class^="InputStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab !important;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab !important;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }

                > input::-webkit-outer-spin-button,
                > input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
            div[class^="FormInputWrapper"] {
                > select[class^="SelectStyle"] {
                    border: 1px solid #9195ab;
                    color: #9195ab !important;
                    opacity: 1;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                    border-radius: 10px;
                }
            }
        `,
    },
    emailGridItem: {
        width: 12,
        css: css`
            margin-bottom: 10px !important;
            padding: 0px;
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > input[class^="InputStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab !important;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab !important;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }
            }
            div[class^="FormInputWrapper"] {
                > select[class^="SelectStyle"] {
                    border: 1px solid #9195ab;
                    color: #9195ab !important;
                    opacity: 1;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                    border-radius: 10px;
                }
            }
        `,
    },
    messageTextField: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
    textboxArea: {
        css: css`
            resize: none;
            border: 1px solid #9195ab !important;
            border-radius: 10px !important;
            color: #9195ab !important;
            opacity: 1;
            font-size: 14px;
            font-weight: 500;
            font-style: normal;
            letter-spacing: 0px;
            text-align: left;
            text-transform: capitalize;
            height: 40px;
            /* padding: 10px !important; */
            &:focus {
                padding: 10px !important;
            }
            &:focus-within {
                padding: 10px !important;
            }
            ::placeholder {
                opacity: 1;
                color: #9195ab !important;
                font-size: 14px;
                font-weight: 500;
                font-style: normal;
                letter-spacing: 0px;
                text-align: left;
                text-transform: capitalize;
            }
        `,
    },

    userNameGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > input[class^="InputStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }
            }
        `,
    },

    lastNameGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > input[class^="InputStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab !important;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab !important;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }
            }
            div[class^="FormInputWrapper"] {
                > select[class^="SelectStyle"] {
                    border: 1px solid #9195ab;
                    color: #9195ab !important;
                    opacity: 1;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    text-transform: capitalize;
                }
            }
        `,
    },

    passwordGridItem: {
        width: 12,
        css: css`
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > select[class^="SelectStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }
            }
        `,
    },
    confirmPasswordGridItem: {
        width: 12,
        css: css`
            div[class^="FormInputWrapper"] {
                margin-top: 0px;
                > select[class^="SelectStyle"] {
                    border: 1px solid #9195ab;
                    opacity: 1;
                    color: #9195ab;
                    font-size: 14px;
                    font-weight: 500;
                    font-style: normal;
                    letter-spacing: 0px;
                    text-align: left;
                    border-radius: 10px;
                    ::placeholder {
                        opacity: 1;
                        color: #9195ab;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                }
            }
        `,
    },
    subscriptionGridItem: {
        width: 12,
        css: css`
            justify-content: start;
            color: ${getColor("secondary")};
            padding: 0 !important;
            font-weight: 500 !important;
        `,
    },
    ManditoryField: {
        width: 12,
        css: css`
            justify-content: start;
            color: ${getColor("secondary")};
            padding: 0 30px 15px !important;
            font-weight: 500 !important;
            margin-left: 10px;
        `,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: {
        width: 12,
        css: css`
            padding: 0px !important;
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: center;
            padding-top: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
        css: css`
            > div {
                display: none;
                margin-top: 8px;
            }
        `,
    },

    passwordRequirementsGridItem: {
        width: 0,
        css: css``,
    },
    passwordTextField: {
        css: css`
            border: 1px solid #9195ab !important;
            border-radius: 10px;
            ::placeholder {
                opacity: 1;
                color: #9195ab;
                font-size: 14px;
                font-weight: 500;
                font-style: normal;
                letter-spacing: 0px;
                text-align: left;
                text-transform: capitalize;
            }
        `,
    },
    confirmPasswordTextField: {
        css: css`
            border: 1px solid ${getColor("secondary")} !important;
            ::placeholder {
                opacity: 1;
                color: #9195ab;
                font-size: 14px;
                font-weight: 500;
                font-style: normal;
                letter-spacing: 0px;
                text-align: left;
                text-transform: capitalize;
            }
        `,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
        css: css`
            display: none;
            text-transform: capitalize;
            color: ${getColor("primary")};
        `,
    },
    signINButton: {
        css: css`
            display: flex;
            justify-content: start;
            span {
                color: ${getColor("secondary")} !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 10px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    buttonLink: {
        css: css`
            border-bottom: 1px solid ${getColor("secondary")};
            display: flex;
            justify-content: start;
            span {
                color: ${getColor("secondary")} !important;

                &:hover {
                    color: ${getColor("primary")} !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 10px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },

    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
    FlexBlox: {
        css: css`
            display: flex;
            margin-bottom: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                ])};
        `,
    },
    ProductRow: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 16px;
        `,
    },
    FlexBlox1: {
        css: css`
            display: flex;
            margin-left: 20px;
            margin-bottom: 20px;
        `,
    },
    ImgHight: {
        css: css`
            height: 85px;
            width: 85px;
        `,
    },
    Right: {
        css: css`
            padding-right: 5px;
            border-right: 1px solid grey;
            width: 110%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        border-right: none;
                        border-bottom: 1px solid grey;
                        padding-right: 0px;
                        padding-bottom: 10px;
                    `,
                    css`
                        width: 100%;
                        border-right: none;
                        border-bottom: 1px solid grey;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },

    PhoneBoxWrapper: {
        width: 12,
        css: css`
            display: flex;
            gap: 7px;
            > div[class^="FormFieldStyle"] {
                display: flex;
                flex-direction: row;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: row;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])};
                > label[class^="TypographyStyle"] {
                    display: flex;
                    align-items: center;
                    justify-content: end;
                    margin-right: 25px;
                    color: ${getColor("secondary")};
                    flex-direction: row-reverse;

                    text-transform: capitalize;
                    gap: 5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                justify-content: start;
                            `,

                            null,
                            null,
                            null,
                            null,
                        ])};
                }
                div[class^="FormInputWrapper"] {
                    margin-top: 0px !important;
                    > select[class^="SelectStyle"] {
                        border: 1px solid ${getColor("secondary")};
                        color: ${getColor("secondary")} !important;
                        opacity: 1;
                        font-size: 14px;
                        padding-right: 24px !important;
                        font-weight: 400;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                    }
                    > span[class^="IconWrapper"] {
                        padding-left: 15px !important;
                        padding: 0px;
                    }
                }
                div[class^="FormInputWrapper"] {
                    margin-top: 0px;
                    > input[class^="InputStyle"] {
                        border: 1px solid ${getColor("secondary")};
                        width: 400px;
                        color: #9195ab !important;
                        opacity: 1;
                        font-size: 14px;
                        font-weight: 500;
                        font-style: normal;
                        letter-spacing: 0px;
                        text-align: left;
                        text-transform: capitalize;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    width: 230px;
                                `,
                                null,
                                null,
                                null,
                                null,
                            ])};
                        ::placeholder {
                            opacity: 1;
                            color: #9195ab;
                            font-size: 14px;
                            font-weight: 500;
                            font-style: normal;
                            letter-spacing: 0px;
                            text-align: left;
                            text-transform: capitalize;
                        }
                    }
                }
            }
        `,
    },
};

const styles = createAccountStyles;
const StyledForm = getStyledWrapper("form");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const ContactUsForm = ({
    shouldLoadAccount,
    loadCurrentAccount,
    editingAccount,
    emailErrorMessage,
    loadCurrentCountries,
    fields,
    countries,
    currentAcc,
    submitContactForm,
    location,
    userName,
    currentUserIsGuest,
    isSignInPage,
    signInUrl,
}: Props) => {
    const history = useHistory();

    React.useEffect(() => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/SignIn");
            } else {
                const returnUrl = location.pathname + location.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
            }
        }
    });
    const phoneArr = currentAcc?.properties.phoneNo?.split("_") || [];
    const [defaultCountryCodeWithDisplay, defaultPhoneNo] =
        phoneArr.length > 1 ? [phoneArr[0].replace("+", "|+"), phoneArr[1]] : ["", ""];
    //
    const { emailRecipients } = fields;
    //
    const [firstName, setfirstName] = React.useState("");
    const [isVisibleFirstDiv, setIsVisibleFirstDiv] = useState(true);
    const [isVisibleSecondDiv, setIsVisibleSecondDiv] = useState(false);
    const [streetAddress1, setStreetAddress1] = React.useState("");
    const [streetAddress2, setStreetAddress2] = React.useState("");
    const [city, setCity] = React.useState("");
    const [zipcode, setZipcode] = React.useState("");
    const [lastName, setlastName] = React.useState("");
    const [ContactUs, setIsSubscribed] = useState(false);
    const [email, setEmail] = React.useState("");
    const [chooseCountry, setchooseCountry] = React.useState("");
    const [selectedCountry, setSelectedCountry] = React.useState("");
    const [chooseState, setChooseState] = React.useState("");
    const [selectedState, setSelectedState] = React.useState("");
    const [defaulatStatevalue, setDefaultStateValue] = React.useState<any[]>([]);
    const [phone, setPhoneNo] = React.useState("");
    const [extension, setExtension] = React.useState("");
    const [company, setCompany] = React.useState("");
    const [countryCodeWithDisplay, setCountryCodeWithDisplay] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [subject, setSubject] = React.useState("");
    const [subjectNumber, setsubjectNumber] = React.useState("");
    const [otherSubject, setOtherSubject] = React.useState("");

    const [Options, setOptions] = React.useState(false);
    const [coffeeMachineValue, setCoffeeMachineValue] = React.useState([
        {
            id: 15310,
            name: "10 oz Wrapped Hot Cup (3 cups)",
            value: "10 oz Wrapped Hot Cup (3 cups)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/15310.png",
        },
        {
            id: 60001987,
            name: "9 oz Wrapped Cold Cup (3 cups)",
            value: "9 oz Wrapped Cold Cup (3 cups)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60001987.png",
        },
        {
            id: 3025005,
            name: "Colgate Toothpaste (1 tube)",
            value: "Colgate Toothpaste (1 tube)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/3025005.png",
        },
        {
            id: 60001959,
            name: "Microfiber Towel (1 blue towel)",
            value: "Microfiber Towel (1 blue towel)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60001959.png",
        },
        {
            id: 60001657,
            name: "Eraser Cleaning Sponge (1 eraser)",
            value: "Eraser Cleaning Sponge (1 eraser)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60001657.png",
        },
        {
            id: 60002153,
            name: "Makeup Remover Wipes (2 packs)",
            value: "Makeup Remover Wipes (2 packs)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60002153.png",
        },
        {
            id: 60002121,
            name: "Cafe Valet Folds of Honor Capsule Regular Coffee (5 capsules)",
            value: "Cafe Valet Folds of Honor Capsule Regular Coffee (5 capsules)  ",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60002121.png",
        },
        {
            id: 60002218,
            name: "Third Rock Coffee Regular Compostable Capsule 100% Rainforest Alliance (5 capsules)",
            value: "Third Rock Coffee Regular Compostable Capsule 100% Rainforest Alliance (5 capsules)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60002218.png",
        },
        {
            id: 60002178,
            name: "Harmony Tea Company Capsule English Breakfast Tea (5 capsules)",
            value: "Harmony Tea Company Capsule English Breakfast Tea (5 capsules)",
            isChecked: false,
            ImagePath: "/UserFiles/freeSamples/60002178.jpg",
        },
    ]);
    const [coffeeMachineParams, setCoffeeMachineParams] = React.useState<string[]>([]);
    //

    const firstNameMessage = siteMessage("Firstname Required");
    const lastNameMessage = siteMessage("Lastname Required");
    const companymessage = siteMessage("Company Required");
    const chooseCountrymessage = siteMessage("chooseCountry_Required");
    const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required_Form");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail_Form");
    const PhoneMessage = siteMessage("Phoneno Required");
    const extensionMessage = siteMessage("Extension Required");
    const countrycodeMessage = siteMessage("countrycode Required");
    const subjectMessage = siteMessage("subject Required");

    // const chooseCountryMessage = siteMessage("Country Required");
    const chooseStateMessage = siteMessage("State Required");
    const streetAddressMessage = siteMessage("Street Address1 Required");
    const cityMessage = siteMessage("City Required");
    const zipcodeMessage = siteMessage("Zipcode Required");
    const coffeeMachineMessage = siteMessage("Select any one Coffee");

    //
    const [firstnameerror, setFirstNameError] = React.useState(firstNameMessage);
    const [streetAddress1Error, setStreetAddress1Error] = React.useState(streetAddressMessage);
    const [lastnameerror, setLastNameError] = React.useState(lastNameMessage);
    const [cityError, setCityError] = React.useState(cityMessage);
    const [zipcodeError, setZipcodeError] = React.useState(zipcodeMessage);
    const [coffeeMachineError, setCoffeeMachineError] = React.useState(coffeeMachineMessage);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [companyerror, setcompanyerror] = React.useState(companymessage);
    const [countryCodeerror, setcountryCodeerror] = React.useState(countrycodeMessage);
    const [chooseStateError, setChooseStateError] = React.useState(chooseStateMessage);
    const [phoneerror, setphoneerror] = React.useState(PhoneMessage);
    const [extensionError, setExtensionError] = React.useState(extensionMessage);
    const [subjecterror, setSubjecterror] = React.useState(subjectMessage);

    const backgroundStyles =
        fields.background === "image"
            ? `background-image: url(${fields.image});
           background-size: cover;`
            : `background-color: ${fields.backgroundColor};`;

    let minimumHeightStyles;
    switch (fields.minimumHeight) {
        case "fullViewport":
            minimumHeightStyles = "height: 130vh;";
            break;
    }

    // const wrapperStyles = {
    //     css: css`
    //         /* width: calc(100vw - 20px + 6px);
    //         margin-left: calc(-50vw + 50% + 5px); */
    //         ${({ theme }: { theme: BaseTheme }) =>
    //             breakpointMediaQueries(theme, [
    //                 css`
    //                     width: calc(100vw - 29px + 39px);
    //                     margin-left: calc(-55vw + 52% + 5px);
    //                 `,
    //                 css`
    //                     width: calc(100vw - 29px + 39px);
    //                     margin-left: calc(-55vw + 52% + 5px);
    //                 `,
    //                 css`
    //                     width: calc(100vw - 20px + 28px);
    //                     margin-left: calc(-51vw + 50% + 5px);
    //                 `,
    //                 css`
    //                     width: calc(100vw - -19px + 6px);
    //                     margin-left: calc(-52vw + 50% + 5px);
    //                 `,
    //                 null,
    //             ])}

    //         ${backgroundStyles}
    //         ${minimumHeightStyles}
    //     `,
    // };

    React.useEffect(() => {
        loadCurrentCountries();
        if (shouldLoadAccount) {
            loadCurrentAccount();
        } else {
            setInitialValues();
        }
    }, []);

    React.useEffect(() => {
        if (countries) {
            countries;
            setDefaultStateValue(countries && countries[0]?.states ? countries[0].states : []);
        }
    }, [countries]);

    React.useEffect(() => {
        if (!isEmpty(currentAcc)) {
            setfirstName(currentAcc?.firstName.toUpperCase() || "");
            setlastName(currentAcc?.lastName.toUpperCase() || "");
            setEmail(currentAcc?.email.toUpperCase() || "");
            setChooseState(currentAcc?.properties.chooseState || "");
            setCompany(currentAcc?.properties.company?.toUpperCase() || "");
            setPhoneNo(defaultPhoneNo || "");
            setCountryCodeWithDisplay(defaultCountryCodeWithDisplay || "");
            setSubject("");
            setOtherSubject("");
            setFirstNameError(currentAcc?.firstName ? "" : firstNameMessage);
            setLastNameError(currentAcc?.lastName ? "" : lastNameMessage);
            setEmailError(currentAcc?.email ? "" : emailRequiredFieldMessage);
            setChooseStateError(currentAcc?.properties.chooseState ? "" : chooseStateMessage);
            setphoneerror(defaultPhoneNo ? "" : PhoneMessage);
            setcompanyerror(currentAcc?.properties.company ? "" : companymessage);
        }
    }, [currentAcc]);

    // EMAIL

    const validateEmail = (email: string) => {
        const emailError = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(emailError as any);
        return !emailError;
    };

    const emailChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateEmail(event.target.value);
        setEmail(event.currentTarget.value);
        updateAccountSettings({ email: event.currentTarget.value });
    };

    // LAST NAME
    const validateLastNameType = (lastName: string) => {
        const lastnameerror = !lastName && lastName.length <= 0 ? (lastNameMessage as string) : "";
        setLastNameError(lastnameerror);
        return !lastnameerror;
    };
    const lastNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateLastNameType(event.target.value);
        setlastName(event.target.value);
    };

    // FIRST NAME
    const validateFirstNameType = (firstName: string) => {
        const firstnameerror = !firstName || firstName?.length <= 0 ? (firstNameMessage as string) : "";
        setFirstNameError(firstnameerror);
        return !firstnameerror;
    };
    const firstnameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setfirstName(event.target.value);
        validateFirstNameType(event.target.value);
    };

    // Street Address
    const validateStreetAdreesType = (streetAddress: string) => {
        const streetAddresserror = !streetAddress || streetAddress?.length <= 0 ? (streetAddressMessage as string) : "";
        setStreetAddress1Error(streetAddresserror);
        return !streetAddresserror;
    };
    const streetAddressChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateStreetAdreesType(event.target.value);
        setStreetAddress1(event.target.value);
    };

    const streetAddress2ChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setStreetAddress2(event.target.value);
    };

    // City
    const validateCityType = (cityName: string) => {
        const cityNameError = !cityName || cityName?.length <= 0 ? (cityMessage as string) : "";
        setCityError(cityNameError);
        return !cityNameError;
    };
    const cityChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateCityType(event.target.value);
        setCity(event.target.value);
    };

    // Zipcode
    const validateZipcodeType = (zipcode: string) => {
        const zipcodeError = !zipcode || zipcode?.length <= 0 ? (zipcodeMessage as string) : "";
        setZipcodeError(zipcodeError);
        return !zipcodeError;
    };
    const zipcodeChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        validateZipcodeType(event.target.value);
        setZipcode(event.target.value);
    };

    // COUNTRY
    // const validatecountryType = (country: string) => {
    //     const chooseCountryerror = !country && country.length <= 0 ? chooseCountryMessage : "";
    //     setchooseCountryerror(chooseCountryerror as any);
    //     return !chooseCountryerror;
    // };

    const validateStateType = (state: string) => {
        const chooseStateError = !state && state.length <= 0 ? chooseStateMessage : "";
        setChooseStateError(chooseStateError as any);
        return !chooseStateError;
    };

    const stateHandler = (stateId: string) => {
        validateStateType(stateId);
        setChooseState(stateId);
        const currentState = defaulatStatevalue?.find(state => stateId === state.id);
        setSelectedState(currentState.abbreviation);
    };
    // COUNTRY CODE
    const validatecountryCode = (countryCodes: string) => {};
    const validatecountryCodeHandler = (countryCodes: string) => {
        validatecountryCode(countryCodes);
        // setCountryCodeWithDisplay(countryCodes);
    };

    // PHONE NUMBER
    const validatephoneType = (phone: string) => {
        const PHONE_NO_REGEX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i;
        const phoneerror = !(phone && PHONE_NO_REGEX.test(phone)) ? (PhoneMessage as string) : "";
        setphoneerror(phoneerror);
        return !phoneerror;
    };

    const validateExtension = (ext: string) => {
        const extError = !ext || ext?.length <= 0 ? (extensionMessage as string) : "";
        setExtensionError(extError);
        return !extError;
    };

    const phoneChangeHandler = (phone: string) => {
        setPhoneNo(phone);
        validatephoneType(phone);
    };

    const extensionChangeHandler = (ext: string) => {
        setExtension(ext);
        validateExtension(ext);
    };
    // COMPANY
    const validatecompanyType = (company: string) => {
        const companyerror = !company || company?.length <= 0 ? (companymessage as string) : "";
        setcompanyerror(companyerror);
        return !companyerror;
    };
    const companyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setCompany(event.target.value);
        validatecompanyType(event.target.value);
    };
    // subject
    const validateSubjectType = (subject: string) => {
        const subjecterror = !subject || subject?.length <= 0 ? (subjectMessage as string) : "";
        setSubjecterror(subjecterror);
        return !subjecterror;
    };
    const subjectChangeHandler = (subject: string) => {
        validateSubjectType(subject);
        if (subject.toLowerCase() === "other") {
            setOptions(true);
        } else if (subject.toLowerCase() !== "other") {
            setOptions(false);
        }
        setSubject(subject);

        const abc = fields.selectDivision?.filter(division => division.fields.SelectList === subject);

        if (abc[0]) {
            setsubjectNumber(abc[0].fields.SelectValue);
        }
    }; // other
    const otherChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setOtherSubject(event.target.value);
    };
    // HideDiv

    const handleHideClick = () => {
        if (!validateNextEnabled()) {
            window.scrollTo({ top: 150 });
            toasterContext.addToast({ body: translate("Please Select atleast 1 product"), messageType: "danger" });
            return;
        }
        setIsVisibleFirstDiv(false);
        setIsVisibleSecondDiv(true);
        window.scrollTo({
            top: 150,
            // behavior: "smooth", // Optional: Adds smooth scrolling behavior
        });
    };
    // message

    const vald = () => {
        validateFirstNameType(firstName);
        validateLastNameType(lastName);
        validateEmail(email);
        validatephoneType(phone);
        validatecompanyType(company);
        validateSubjectType(subject);
    };

    const toasterContext = useContext(ToasterContext);
    const PhoneWithCountryCode = `${countryCodeWithDisplay.replace("|", "")}-${phone}`;

    const validateCoffeeType = (coffee: any) => {
        const coffeeMachineError = !coffee || coffee?.length <= 0 ? (coffeeMachineMessage as string) : "";
        setCoffeeMachineError(coffeeMachineError);
        return !coffeeMachineError;
    };

    const coffeeMachineHandler = (value: string) => {
        const updatedCoffee =
            coffeeMachineValue &&
            coffeeMachineValue.map(val => {
                if (val.value === value) {
                    val.isChecked = !val.isChecked;
                }
                return val;
            });
        const coffeeMachineParams = updatedCoffee
            .filter(coffeeIsSelected => {
                return coffeeIsSelected.isChecked;
            })
            .map(val => {
                return `${val.name}, `;
            });
        validateCoffeeType(coffeeMachineParams);
        setCoffeeMachineValue(updatedCoffee);
        setCoffeeMachineParams(coffeeMachineParams);
    };

    const validateSubmitEnabled = () => {
        return !(
            firstnameerror ||
            lastnameerror ||
            companyerror ||
            phoneerror ||
            extensionError ||
            emailError ||
            subjecterror
        );
    };
    const validateNextEnabled = () => {
        return !coffeeMachineError;
    };

    const updateSettingsHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        vald();
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            // window.scrollTo(0, 0);
            toasterContext.addToast({ body: translate("Please fill all required fields"), messageType: "danger" });
            return;
        }

        const obj: any = {
            // onSuccess: () => {
            //     toasterContext.addToast({ body: translate("Successfull"), messageType: "success" });
            // },

            firstName,
            lastName,
            countries,
            chooseState,
            // chooseCountry,
            phone,
            email,
            subject,
            ContactUs,
            otherSubject,
        };
        submitContactForm({
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            // Country: selectedCountry,

            PhoneNumber: phone,
            Extension: extension,
            CompanyName: company,
            StreetAddress1: streetAddress1,
            StreetAddress2: streetAddress2,
            City: city,
            State: selectedState,
            Zip: zipcode,
            NumberOfRooms: subject,
            ContactUs,
            TypeofCoffeeMachine: coffeeMachineParams,
            OtherSubject: otherSubject,
            defaultEmailAddress: emailRecipients,
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Successfull"), messageType: "success" });
                history.push("/Thankyou");
                // test();
            },
            onComplete() {
                // "this" is targeting the object being created, not the parent SFC

                this.onSuccess?.();
            },
        });
    };

    const test = () => {
        setfirstName("");
        setlastName("");
        setEmail("");
        setchooseCountry("");
        setPhoneNo("");
        setCompany("");
        setSubject("");
        setOtherSubject("");
        setCountryCodeWithDisplay("");
        setStreetAddress1("");
        setStreetAddress2("");
        setCity("");
        setZipcode("");
        setSelectedState("");
        setExtension("");
        setSelectedCountry("");
        setCoffeeMachineValue([
            {
                id: 15310,
                name: "10 oz Wrapped Hot Cup (3 cups)",
                value: "10 oz Wrapped Hot Cup (3 cups)",
                isChecked: false,
                ImagePath: "/UserFiles/Cup.png",
            },
            {
                id: 60001987,
                name: "9 oz Wrapped Cold Cup (3 cups)",
                value: "9 oz Wrapped Cold Cup (3 cups)",
                isChecked: false,
                ImagePath: "/UserFiles/test.jpg",
            },
            {
                id: 3025005,
                name: "Colgate Toothpaste (1 tube)",
                value: "Colgate Toothpaste (1 tube)",
                isChecked: false,
                ImagePath: "/UserFiles/thumb.jpg",
            },
            {
                id: 60001959,
                name: "Microfiber Towel (1 blue towel)",
                value: "Microfiber Towel (1 blue towel)",
                isChecked: false,
                ImagePath: "/UserFiles/test.jpg",
            },
            {
                id: 60001657,
                name: "Eraser Cleaning Sponge (1 eraser)",
                value: "Eraser Cleaning Sponge (1 eraser)",
                isChecked: false,
                ImagePath: "/UserFiles/Hairdrier.jpg",
            },
            {
                id: 60002153,
                name: "Makeup Remover Wipes (2 packs)",
                value: "Makeup Remover Wipes (2 packs)",
                isChecked: false,
                ImagePath: "/UserFiles/test.jpg",
            },
            {
                id: 60002121,
                name: "Cafe Valet Folds of Honor Capsule Regular Coffee (5 capsules)",
                value: "Cafe Valet Folds of Honor Capsule Regular Coffee (5 capsules)",
                isChecked: false,
                ImagePath: "/UserFiles/Hairdrier.jpg",
            },
            {
                id: 60002218,
                name: "Third Rock Coffee Regular Compostable Capsule 100% Rainforest Alliance (5 capsules)",
                value: "Third Rock Coffee Regular Compostable Capsule 100% Rainforest Alliance (5 capsules)",
                isChecked: false,
                ImagePath: "/UserFiles/MaxWell.png",
            },
            {
                id: 60002178,
                name: "Harmony Tea Company Capsule English Breakfast Tea (5 capsules)",
                value: "Harmony Tea Company Capsule English Breakfast Tea (5 capsules)",
                isChecked: false,
                ImagePath: "/UserFiles/comb.png",
            },
        ]);
        setCoffeeMachineParams([]);
        setIsSubmitted(false);
        setFirstNameError(firstNameMessage);
        setLastNameError(lastNameMessage);
        setEmailError(emailRequiredFieldMessage);
        setcompanyerror(companymessage);
        setphoneerror(PhoneMessage);
        setExtensionError(extensionMessage);
        setSubjecterror(subjectMessage);
        setStreetAddress1Error(streetAddressMessage);
        setCityError(cityMessage);
        setZipcodeError(zipcodeMessage);
        setCoffeeMachineError(coffeeMachineMessage);
        setChooseStateError(chooseStateMessage);
    };
    return (
        <>
            <StyledWrapper
                className="banner-wrapper"
                //  {...wrapperStyles}
            >
                {isVisibleFirstDiv && (
                    <StyledWrapper>
                        <GridItem {...styles.coffeeWrapGridItem}>
                            <Typography {...styles.boldTextSpan}>
                                {translate("Sample select items from Courtesy  Products for Free")}
                            </Typography>
                            <Typography {...styles.SecondBold}>
                                {translate(
                                    "Please select your desired products by checking the box next to each item (number of items included in sample request is listed)",
                                )}
                            </Typography>
                            {/* {coffeeMachineValue &&
                                            coffeeMachineValue.map(coffee => ( */}
                            <StyledWrapper {...styles.FlexBlox}>
                                <StyledWrapper {...styles.Right}>
                                    <CheckboxGroup {...styles.checkboxGroup} error={isSubmitted && coffeeMachineError}>
                                        {coffeeMachineValue &&
                                            coffeeMachineValue.map(coffee => (
                                                // <Checkbox
                                                //     {...styles.checkbox}
                                                //     key={coffee.id}
                                                //     checked={coffee.isChecked}
                                                //     onChange={() => coffeeMachineHandler(coffee.value)}
                                                //     data-test-selector={`coffee${coffee.id}`}
                                                // >
                                                // eslint-disable-next-line react/jsx-key
                                                <StyledWrapper {...styles.ProductRow}>
                                                    <LazyImage {...styles.ImgHight} src={coffee.ImagePath}></LazyImage>
                                                    <StyledWrapper {...styles.ItemColumn}>
                                                        <StyledWrapper> {coffee.name}</StyledWrapper>
                                                        <StyledWrapper> {`item #: ${coffee.id}`}</StyledWrapper>
                                                        <Checkbox
                                                            {...styles.checkbox}
                                                            key={coffee.id}
                                                            checked={coffee.isChecked}
                                                            onChange={() => coffeeMachineHandler(coffee.value)}
                                                            data-test-selector={`coffee${coffee.id}`}
                                                        ></Checkbox>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                                // </Checkbox>
                                            ))}
                                    </CheckboxGroup>
                                </StyledWrapper>
                                <StyledWrapper>
                                    <StyledWrapper {...styles.TextSpan}>
                                        {translate(
                                            "For samples of our coffee makers, drip coffee in disposable brew baskets, and assortment of irons and other operating supplies please call 1-800-325-4500 or check the box below and complete the contact information and one of our representatives will be glad to assist you!",
                                        )}
                                    </StyledWrapper>

                                    <CheckboxGroup {...styles.TextSpan}>
                                        <Checkbox
                                            onChange={(e, value) => setIsSubscribed(value)}
                                            checked={ContactUs}
                                            data-test-selector="contactUs_Subscription"
                                        >
                                            <Typography {...styles.ContactUs}>
                                                {siteMessage("ContactUs_Subscribe_Promotions")}
                                            </Typography>
                                        </Checkbox>
                                    </CheckboxGroup>
                                    {fields.divisions?.map((division, index) => {
                                        return (
                                            <>
                                                <StyledWrapper {...styles.FlexBlox1}>
                                                    <LazyImage
                                                        {...styles.ImgHight}
                                                        src={division.fields.ProductImg}
                                                    ></LazyImage>
                                                    <StyledWrapper {...styles.ItemColumn}>
                                                        <StyledWrapper>{division.fields.ProductTitle} </StyledWrapper>
                                                        <StyledWrapper> {division.fields.ProductNumber}</StyledWrapper>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </>
                                        );
                                    })}
                                </StyledWrapper>
                            </StyledWrapper>
                            {/* ))} */}
                        </GridItem>
                        <GridItem {...styles.submitGridItem}>
                            <Button
                                {...styles.submitButton}
                                onClick={handleHideClick}
                                // disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                                // disabled={isChecked === false}
                                // data-test-selector="createAccount_createButton"
                            >
                                {translate("NEXT")}
                            </Button>
                        </GridItem>
                    </StyledWrapper>
                )}
                {isVisibleSecondDiv && (
                    <>
                        <StyledForm {...styles.form}>
                            <GridContainer {...styles.mainGridContainer}>
                                <GridItem {...styles.coffeeWrapGridItem}>
                                    <Typography {...styles.boldTextSpan}>
                                        {translate("Address and Contact Information")}
                                    </Typography>
                                    <Typography {...styles.SecondBold}>
                                        {translate(
                                            "Please complete the form below to receive your FREE items from Courtesy Products. (We only ship to customer hotel/business addresses, no home addresses please.)",
                                        )}
                                    </Typography>
                                </GridItem>
                                <StyledWrapper {...styles.BackgroundWrapper}>
                                    <Typography {...styles.boldTextSpan}>{translate("Contact Information")}</Typography>
                                    <Typography {...styles.boldTextSpan}>{translate("Send Samples to.")}</Typography>
                                    <GridItem {...styles.userGridItem}>
                                        <GridContainer {...styles.userGridContainer}>
                                            <GridItem {...styles.divWrapContainer}>
                                                <GridItem {...styles.userNameGridItem}>
                                                    <TextField
                                                        {...styles.userNameTextField}
                                                        type="text"
                                                        label={translate("First Name ")}
                                                        // placeholder={translate("First Name *")}
                                                        onChange={firstnameChangeHandler}
                                                        // onBlur={e => validateFirstNameType(e.currentTarget.value)}
                                                        value={firstName}
                                                        // data-test-selector="createAccount_firstname"
                                                        required
                                                        error={isSubmitted && firstnameerror}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.emailGridItem}>
                                                    <TextField
                                                        {...styles.emailTextField}
                                                        type="text"
                                                        label={translate("Hotel/Company Name ")}
                                                        // placeholder={translate("Hotel/Company Name *")}
                                                        onChange={companyChangeHandler}
                                                        value={company}
                                                        required
                                                        error={isSubmitted && companyerror}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.inputFieldGridItem}>
                                                    <TextField
                                                        {...styles.userNameTextField}
                                                        type="text"
                                                        label={translate("City")}
                                                        // placeholder={translate("City")}
                                                        onChange={cityChangeHandler}
                                                        // onBlur={e => validateFirstNameType(e.currentTarget.value)}
                                                        value={city}
                                                        // data-test-selector="createAccount_firstname"
                                                        required
                                                        error={isSubmitted && cityError}
                                                    />
                                                </GridItem>
                                            </GridItem>
                                            <GridItem {...styles.divWrapContainer}>
                                                <GridItem {...styles.lastNameGridItem}>
                                                    <TextField
                                                        {...styles.emailTextField}
                                                        type="text"
                                                        label={translate("Last Name ")}
                                                        // placeholder={translate("Last Name *")}
                                                        onChange={lastNameChangeHandler}
                                                        maxLength={256}
                                                        required
                                                        value={lastName}
                                                        error={isSubmitted && lastnameerror}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.inputFieldGridItem}>
                                                    <TextField
                                                        type="text"
                                                        label={translate("Contact Name ")}
                                                        // placeholder={translate("Contact Name *")}
                                                        value={extension}
                                                        error={isSubmitted && extensionError}
                                                        required
                                                        onChange={e => extensionChangeHandler(e.target.value)}
                                                    ></TextField>
                                                </GridItem>
                                                <GridItem {...styles.emailGridItem}>
                                                    <Select
                                                        {...styles.SelectIconSvg}
                                                        label={translate("State")}
                                                        // placeholder={translate("State *")}
                                                        value={chooseState}
                                                        defaultValue={" "}
                                                        error={isSubmitted && chooseStateError}
                                                        // onClick={!countries ? loadCurrentCountries : undefined}
                                                        onChange={e => stateHandler(e.target.value)}
                                                        required
                                                    >
                                                        {" "}
                                                        ?
                                                        {!defaulatStatevalue.length && (
                                                            <>
                                                                <option value="">{translate("")}</option>
                                                                <option value="">Loading...</option>
                                                            </>
                                                        )}
                                                        {defaulatStatevalue.length && (
                                                            <option value="">{translate(" ")}</option>
                                                        )}
                                                        {defaulatStatevalue.length &&
                                                            defaulatStatevalue?.map(stateVal => (
                                                                <option value={stateVal.id} key={stateVal.id}>
                                                                    {stateVal.name}
                                                                </option>
                                                            ))}
                                                    </Select>
                                                </GridItem>
                                            </GridItem>

                                            <GridItem {...styles.divWrapContainer}>
                                                <GridItem {...styles.emailGridItem}>
                                                    <TextField
                                                        {...styles.emailTextField}
                                                        type="email"
                                                        label={translate("E-mail Address")}
                                                        // placeholder={translate("Email Address *")}
                                                        required
                                                        onChange={emailChangeHandler}
                                                        value={email}
                                                        // data-test-selector="createAccount_email"
                                                        maxLength={256}
                                                        error={isSubmitted && emailError}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.inputFieldGridItem}>
                                                    <TextField
                                                        {...styles.userNameTextField}
                                                        type="text"
                                                        label={translate("Hotel/Business Address")}
                                                        // placeholder={translate("Address 1")}
                                                        onChange={streetAddressChangeHandler}
                                                        // onBlur={e => validateFirstNameType(e.currentTarget.value)}
                                                        value={streetAddress1}
                                                        // data-test-selector="createAccount_firstname"
                                                        required
                                                        error={isSubmitted && streetAddress1Error}
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.inputFieldGridItem}>
                                                    <TextField
                                                        {...styles.userNameTextField}
                                                        type="text"
                                                        label={translate("Zip Code")}
                                                        // placeholder={translate("Zip")}
                                                        onChange={zipcodeChangeHandler}
                                                        // onBlur={e => validateFirstNameType(e.currentTarget.value)}
                                                        value={zipcode}
                                                        // data-test-selector="createAccount_firstname"
                                                        required
                                                        error={isSubmitted && zipcodeError}
                                                    />
                                                </GridItem>
                                            </GridItem>

                                            {/* <GridItem {...styles.emailGridItem}>
                                                <Select
                                                    {...styles.SelectIconSvg}
                                                    label={translate("Choose Country")}
                                                    // placeholder={translate("Choose Country *")}
                                                    value={chooseCountry}
                                                    defaultValue={" "}
                                                    error={isSubmitted && chooseCountryerror}
                                                    // onClick={!countries ? loadCurrentCountries : undefined}
                                                    onChange={e => counytryHandler(e.target.value)}
                                                    required
                                                >
                                                    {" "}
                                                    ?
                                                    {!countries && (
                                                        <>
                                                            <option value="">{translate("")}</option>
                                                            <option value="">Loading...</option>
                                                        </>
                                                    )}
                                                    {countries && (
                                                        <option value="">{translate("Choose Country *")}</option>
                                                    )}
                                                    {countries &&
                                                        countries?.map(country => (
                                                            <option value={country.id} key={country.id}>
                                                                {country.name}
                                                            </option>
                                                        ))}
                                                </Select>
                                            </GridItem> */}

                                            <GridItem {...styles.whereToSendGridItem}>
                                                <GridItem {...styles.divWrapContainer}>
                                                    <GridItem {...styles.inputFieldGridItem}>
                                                        <TextField
                                                            type="number"
                                                            label={translate("Phone Number")}
                                                            // placeholder={translate("Phone")}
                                                            value={phone}
                                                            error={isSubmitted && phoneerror}
                                                            required
                                                            onChange={e => phoneChangeHandler(e.target.value)}
                                                        ></TextField>
                                                    </GridItem>
                                                    <GridItem {...styles.inputFieldGridItem}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            type="text"
                                                            label={translate("Hotel/Business Address 2")}
                                                            // placeholder={translate("Street Address 2")}
                                                            onChange={streetAddress2ChangeHandler}
                                                            // onBlur={e => validateFirstNameType(e.currentTarget.value)}
                                                            value={streetAddress2}
                                                        />
                                                    </GridItem>
                                                    <GridItem {...styles.emailGridItem}>
                                                        <Select
                                                            {...styles.SelectIconSvg}
                                                            label={translate("Number of Rooms")}
                                                            // placeholder={translate("subject *")}
                                                            value={subject}
                                                            error={isSubmitted && subjecterror}
                                                            onChange={e => subjectChangeHandler(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">{translate(" ")}</option>
                                                            {fields.selectDivision?.map(division => (
                                                                <>
                                                                    <option
                                                                        key={division.fields.SelectList}
                                                                        value={`${division.fields.SelectList}`}
                                                                    >
                                                                        {division.fields.SelectList}
                                                                    </option>
                                                                </>
                                                            ))}
                                                        </Select>
                                                    </GridItem>
                                                </GridItem>
                                            </GridItem>

                                            {/* <GridItem {...styles.messageTextField}>
    <TextArea
        {...styles.textboxArea}
        label="Message"
        placeholder={translate("message *")}
        onChange={e => messageChangeHandler(e.currentTarget.value)}
        value={message}
        required
        error={isSubmitted && messageerror}
    />
</GridItem> */}
                                            {/* <GridItem {...styles.ManditoryField}>
{translate("*these fields are required")}
</GridItem> */}
                                        </GridContainer>
                                    </GridItem>
                                </StyledWrapper>
                            </GridContainer>
                        </StyledForm>
                        <GridItem {...styles.submitGridItem}>
                            <Button {...styles.submitButton} onClick={updateSettingsHandler}>
                                {translate("submit")}
                            </Button>
                        </GridItem>
                    </>
                )}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ContactUsForm),
    definition: {
        group: "Basic",
        displayName: "takeAwayForm",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
            },
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
            },
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
            },
            {
                name: fields.selectDivision,
                displayName: "Subject",
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.SelectList;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "SelectValue",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "SelectList",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { ProductTitle } }) => ProductTitle || "title",
                defaultValue: [],
                fieldType: "Translatable",

                fieldDefinitions: [
                    {
                        name: "ProductImg",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Product Image",
                    },
                    {
                        name: "ProductTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "ProductNumber",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.emailRecipients,
                displayName: " Default Email recipients",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
